import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { fetchEmployees, addCandidate, fetchCandidatesbynumber } from "../api/customerapi";




const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Canddataentry = () => {

    const classes = useStyles();
    
    //const dispatch=useDispatch();
    const [candidateData, setcandidateData] =useState({
        name: "",   
    });
    
    const [eData, seteData]=useState([]);
    const [roundData, setroundData]=useState([]);
      const [hremp, sethremp] =useState([]);
    const getcandidates = async () => {
        try{
        const data = await fetchEmployees();
        sethremp(data.data.filter(emp => emp.role=="HR"))
        seteData(data.data.filter(emp => !(emp.role=="Ex-employee" || emp.role=="Sales" || emp.role=="SME" || emp.role=="External") ))
    }catch(err){
        console.log(err)
      }
    }

   

    useEffect(() => {
        getcandidates()
        
        
    }, [])

    const addcp = () => {
        //console.log(count)
    
        setroundData(
            roundData.length == 0 ? [{ id: uuidv4() }] : [...roundData, { id: uuidv4() }]
        );
      };
    
      const removecp = () => {
        setroundData([...roundData].slice(0, roundData.length - 1));
      };

    //console.log(dest);

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        const finalcandidateData={...candidateData, rounds:roundData, createdAt:new Date(), updatedAt:new Date()}
        const data=await fetchCandidatesbynumber(candidateData.contact)
        // if(data.data.length > 0){
        const addcandidateResponse= await addCandidate(finalcandidateData);
        // dispatch(createCustomer(finalcustData));
        //console.log(addcustResponse.data.cust_id);
        if(addcandidateResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("New candidate added with candidate id "+addcandidateResponse.data.candidate_id);
            window.location = ("/canddataentry/"+addcandidateResponse.data.candidate_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
      // }else{
      //   alert("Phone number already exists")
      // }
        //dispatch(createHotel(finalhotelData));
    }catch(err){
        console.log(err)
      }
        
    }

    const updateNthItem = (index, newValue, key) => {
      setroundData((prevItems) => {
        // Create a copy of the array
        const updatedItems = [...prevItems];
  
        // Replace the nth item (ensure index is valid)
        if (index >= 0 && index < updatedItems.length) {
          updatedItems[index] = { ...updatedItems[index], [key]: newValue };
        }
  
        return updatedItems; // Return the new array
      });
    };

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add New Candidate</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  required label="Name"  value={candidateData.name} className={classes.textField} onChange={(e)=> setcandidateData({...candidateData, name: e.target.value})}/>
                <TextField variant="standard"  label="Email"  value={candidateData.email} className={classes.textField} onChange={(e)=> setcandidateData({...candidateData, email: e.target.value})}/>
                <TextField variant="standard"  label="Contact (number)"  value={candidateData.contact} className={classes.textField} onChange={(e)=> setcandidateData({...candidateData, contact: e.target.value})}/>
                
                
            </FormGroup>


            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Source">Source</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Source" onChange={(e)=> setcandidateData({...candidateData, source: e.target.value})}>
                <MenuItem value={"Reference"}>Reference</MenuItem>
                    <MenuItem value={"Internshala"}>Internshala</MenuItem>
                    <MenuItem value={"WorkIndia"}>WorkIndia</MenuItem>
                    <MenuItem value={"Naukri"}>Naukri</MenuItem>
                    <MenuItem value={"Indeed"}>Indeed</MenuItem>
                    <MenuItem value={"Shine"}>Shine</MenuItem>
                    <MenuItem value={"FoundIt"}>FoundIt</MenuItem>
                    <MenuItem value={"Recruitment Groups"}>Recruitment Groups</MenuItem>
                    <MenuItem value={"LinkedIn Ads"}>LinkedIn Ads</MenuItem>
                    <MenuItem value={"LinkedIn Post"}>LinkedIn Post</MenuItem>
                    <MenuItem value={"Campus"}>Campus</MenuItem>
                </Select>
                </FormControl>
            <TextField variant="standard"  label="Source Details"  value={candidateData.proxy_name} className={classes.textField} onChange={(e)=> setcandidateData({...candidateData, source_details: e.target.value})}/>
            
            <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Position">Position</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Position" value={candidateData.position} onChange={(e)=> setcandidateData({...candidateData, position: e.target.value})}>
                <MenuItem value={"L1-Sales"}>L1-Sales</MenuItem>
                    <MenuItem value={"L2-Sales"}>L2-Sales</MenuItem>
                    <MenuItem value={"L3-Sales"}>L3-Sales</MenuItem>
                    <MenuItem value={"L4-Sales"}>L4-Sales</MenuItem>
                    <MenuItem value={"L1-Operations"}>L1-Operations</MenuItem>
                    <MenuItem value={"L2-Operations"}>L2-Operations</MenuItem>
                    <MenuItem value={"L3-Operations"}>L3-Operations</MenuItem>
                    <MenuItem value={"L4-Operations"}>L4-Operations</MenuItem>
                    <MenuItem value={"L1-Marketing"}>L1-Marketing</MenuItem>
                    <MenuItem value={"L2-Marketing"}>L2-Marketing</MenuItem>
                    <MenuItem value={"L3-Marketing"}>L3-Marketing</MenuItem>
                    <MenuItem value={"L4-Marketing"}>L4-Marketing</MenuItem>
                    <MenuItem value={"L1-Accounts"}>L1-Accounts</MenuItem>
                    <MenuItem value={"L2-Accounts"}>L2-Accounts</MenuItem>
                    <MenuItem value={"L3-Accounts"}>L3-Accounts</MenuItem>
                    <MenuItem value={"L4-Accounts"}>L4-Accounts</MenuItem>
                    <MenuItem value={"L1-Product"}>L1-Product</MenuItem>
                    <MenuItem value={"L2-Product"}>L2-Product</MenuItem>
                    <MenuItem value={"L3-Product"}>L3-Product</MenuItem>
                    <MenuItem value={"L4-Product"}>L4-Product</MenuItem>
                    <MenuItem value={"L1-HR & Admin"}>L1-HR & Admin</MenuItem>
                    <MenuItem value={"L2-HR & Admin"}>L2-HR & Admin</MenuItem>
                    <MenuItem value={"L3-HR & Admin"}>L3-HR & Admin</MenuItem>
                    <MenuItem value={"L4-HR & Admin"}>L4-HR & Admin</MenuItem>
                    <MenuItem value={"L1-Tech"}>L1-Tech</MenuItem>
                    <MenuItem value={"L2-Tech"}>L2-Tech</MenuItem>
                    <MenuItem value={"L3-Tech"}>L3-Tech</MenuItem>
                    <MenuItem value={"L4-Tech"}>L4-Tech</MenuItem>
                    <MenuItem value={"L5"}>L5</MenuItem>
                    <MenuItem value={"L6"}>L6</MenuItem>
                    <MenuItem value={"L7"}>L7</MenuItem>
                    
                </Select>
                </FormControl>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="HR">HR</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Manager" value={candidateData.hr_name} onChange={(e)=> setcandidateData({...candidateData, hr_name: e.target.value})}>
                    
                    {hremp.map(emp => {
                    return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>})}
                    
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Status">Final Status</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Status" value={candidateData.final_status} onChange={(e)=> setcandidateData({...candidateData, final_status: e.target.value})}>
                <MenuItem value={"Deployed"}>Deployed</MenuItem>
                    <MenuItem value={"Joined"}>Joined</MenuItem>
                    <MenuItem value={"Selected"}>Selected</MenuItem>
                    <MenuItem value={"Did not join"}>Did not join</MenuItem>
                    <MenuItem value={"Rejected"}>Rejected</MenuItem>
                    <MenuItem value={"Declined"}>Declined</MenuItem>
                    <MenuItem value={"Awaiting Task"}>Awaiting Task</MenuItem>
                    <MenuItem value={"In Process"}>In Process</MenuItem>
                      <MenuItem value={"Scheduled"}>Scheduled</MenuItem>
                    <MenuItem value={"Open"}>Open</MenuItem>
                    
                </Select>
                </FormControl>
                 <TextField variant="standard"  required label="Notice Period" InputLabelProps={{ shrink: true }} value={candidateData.notice_period} className={classes.textField} onChange={(e)=> setcandidateData({...candidateData, notice_period: e.target.value})}/>
                </FormGroup>
                <Typography variant="h6" align="center" className={classes.headertext}> Rounds </Typography>
                {roundData && roundData.map((item) => {
            return (
              <div id="rounddata">
                <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
                <InputLabel id="Round">Round</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Round"  value={item.round_name} onChange={(e) => updateNthItem(roundData.indexOf(item), e.target.value, "round_name")}>
                    <MenuItem value={"CV Selection"}>CV Selection</MenuItem>
                    <MenuItem value={"First Call Round"}>First Call Round</MenuItem>
                    <MenuItem value={"TL/Manager Round"}>TL/Manager Round</MenuItem>
                    <MenuItem value={"Task Round"}>Task Round</MenuItem>
                    <MenuItem value={"HR Round"}>HR Round</MenuItem>
                    <MenuItem value={"Management Round"}>Management Round</MenuItem>
                    <MenuItem value={"Final Round"}>Final Round</MenuItem>
                </Select>
                </FormControl>
                  <TextField
                    variant="standard"
                    label="Date"
                    type="Date"
                    id="Date"
                    InputLabelProps={{ shrink: true }}
                    value={
                      item.round_date === undefined
                        ? ""
                        : item.round_date.split("T").slice(0, 1)
                    }
                    className={classes.textField}
                    onChange={(e) => updateNthItem(roundData.indexOf(item), e.target.value, "round_date")}
                  />
                  <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Interviewer">Interviewer</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Interviewer"  value={item.round_interviewer} onChange={(e) => updateNthItem(roundData.indexOf(item), e.target.value, "round_interviewer")}>
                    
                    {eData.map(emp => {
                    return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>})}
                    
                </Select>
                </FormControl>
                  
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
                <InputLabel id="Result">Result</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Result" value={item.round_result} onChange={(e) => updateNthItem(roundData.indexOf(item), e.target.value, "round_result")}>
                    <MenuItem value={"Selected"}>Selected</MenuItem>
                    <MenuItem value={"Rejected"}>Rejected</MenuItem>
                    <MenuItem value={"Not Appeared"}>Not Appeared</MenuItem>
                    <MenuItem value={"Scheduled"}>Scheduled</MenuItem>
                    <MenuItem value={"Unable to connect 1"}>Unable to connect 1</MenuItem>
                    <MenuItem value={"Unable to connect 2"}>Unable to connect 2</MenuItem>
                    <MenuItem value={"Unable to connect 3"}>Unable to connect 3</MenuItem>
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
                <InputLabel id="Reason">Reason</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Reason"  value={item.round_reason} onChange={(e) => updateNthItem(roundData.indexOf(item), e.target.value, "round_reason")}>
                    <MenuItem value={"Location"}>Location</MenuItem>
                    <MenuItem value={"Office Time"}>Office Time</MenuItem>
                    <MenuItem value={"Holidays"}>Holidays</MenuItem>
                    <MenuItem value={"Communication"}>Communication</MenuItem>
                    <MenuItem value={"Intent"}>Intent</MenuItem>
                    <MenuItem value={"Culture"}>Culture</MenuItem>
                   
                    <MenuItem value={"Skill"}>Skill</MenuItem>
                    <MenuItem value={"All Okay"}>All Okay</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                </Select>
                </FormControl>
                 
                  <TextField
                    variant="standard"
                    label="Comment"
                    InputLabelProps={{ shrink: true }}
                    name={roundData.indexOf(item)}
                    value={item.round_comment}
                    className={classes.textField}
                    onChange={(e) => updateNthItem(roundData.indexOf(item), e.target.value, "round_comment")}
                  />
                  
                </FormGroup>
              </div>
            );
          })}

          <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addcp}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removecp}
            >
              {" "}
              - Tranche
            </Button>
          </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
            </FormGroup>
              
            </form>
        </Paper>
     );
}

export default Canddataentry;